import { Typography } from '@pwskills/rachnaui';
import React from 'react';
import Image from 'next/image';
import { INews } from '@/interfaces/categoryPage';
import { dateFormatter } from '@/utils/helper/helperFunction';
import { companyImage } from '@/utils/common/env.constants';

const NewsCard = (props: INews) => {
  const { _id, thumbnail, date, title, url, newsFrom } = props;
  const datePublished = dateFormatter(date)?.split(',');

  const openLinkInNewTab = () => {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'nofollow';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body?.removeChild(anchor);
  };

  return (
    <div
      className="!w-full medium:!w-[411px] shrink-0 flex flex-col p-4 medium:!p-6 bg-[#F8FAFB] rounded  cursor-pointer"
      key={_id}
      onClick={() => openLinkInNewTab()}
    >
      <div className="flex flex-grow">
        <div className="flex flex-col gap-5 w-full">
          <div className="flex flex-row justify-between items-center">
            <div>
              <Typography variant="regular" component="body-regular" className="text-[#757575]">
                {datePublished?.[0]}, {datePublished?.[1]}
              </Typography>
            </div>
            <div>
              <img
                src={`${companyImage}/company_logos/${newsFrom?.companyLogoFileName}`}
                height={16}
                width={78}
                alt="sa"
                className="h-6"
              />
            </div>
          </div>

          <div className="flex flex-col justify-end flex-grow">
            <div className="mb-1 flex h-[66px] medium:h-[90px]">
              <Typography
                variant="semi-bold"
                component="body-regular"
                className="text-[#3D3D3D] small:!text-[14px]  !leading-[22px] medium:!text-[20px] medium:!leading-[30px] line-clamp-3"
              >
                {title}
              </Typography>
            </div>
            <div className="flex mt-4 relative w-full h-[200px] overflow-hidden">
              <div className="absolute inset-0 w-full h-full rounded overflow-hidden">
                <img
                  src={thumbnail}
                  alt="thumbnail"
                  className="w-full h-full transition-transform duration-300 hover:scale-110"
                />
              </div>
            </div>

            <div className="flex flex-row justify-between items-center mt-[13px]">
              <div>
                <Typography variant="regular" component="body-regular" className="text-[#757575]">
                  Know More
                </Typography>
              </div>
              <div>
                <Image
                  src="/images/categoryPage/forwardArrow.svg"
                  alt="right-arw"
                  height={24}
                  width={24}
                  className="w-6 h-6"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
